// src/auth.js
import { createContext, useContext, useEffect, useState } from "react";

const AuthCtx = createContext(undefined);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const u = localStorage.getItem("user");
    return u ? JSON.parse(u) : null;
  });
  const [token, setToken] = useState(() => localStorage.getItem("auth_token"));
  const [loading, setLoading] = useState(false);

  useEffect(() => {
  if (!token) return;               // no token => no verify
  let ignore = false;
  const controller = new AbortController();

  async function verify() {
    setLoading(true);
    try {
      // IMPORTANT: correct absolute/relative URL
      const res = await fetch("https://gantasoft.in/rankridgeschool/dev/v1/users/apis/me.php", {
        headers: { Authorization: `Bearer ${token}` },
        signal: controller.signal,
      });

      // If CORS or 500 happens, res.ok will be false
      const json = await res.json().catch(() => ({}));

      if (!ignore && res.ok && json.success) {
        setUser(json.user);
        localStorage.setItem("user", JSON.stringify(json.user));
      } else if (!ignore) {
        // Soft-fail: don't nuke login on verify errors in dev
        console.warn("verify failed; continuing session");
      }
    } catch (e) {
      if (!ignore) console.warn("verify error", e);
    } finally {
      if (!ignore) setLoading(false);   // ✅ always clear loading
    }
  }

  verify();
  return () => { ignore = true; controller.abort(); };
}, [token]);

  function login({ user, token }) {
    localStorage.setItem("auth_token", token);
    localStorage.setItem("user", JSON.stringify(user));
    setToken(token);
    setUser(user);
  }
  function logout() {
    localStorage.removeItem("auth_token");
    localStorage.removeItem("user");
    setToken(null);
    setUser(null);
  }

  const value = { user, token, loading, login, logout };
  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
}

export function useAuth() {
  const ctx = useContext(AuthCtx);
  if (ctx === undefined) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return ctx;
}
